<script setup>
// Define props
const props = defineProps({
    contentMainHeadlineConfig: {
        type: Object,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                title: value => value === undefined || typeof value === 'string',
                align: value => value === undefined || (typeof value === 'string' && ['center'].includes(value)),
                simple: value => value === undefined || typeof value === 'boolean',
                twoLines: value => value === undefined || typeof value === 'boolean'
            }

            return Object.entries(validations).every(([key, validation]) => validation(rawValue[key]))
        }
    }
})
// Markdown
const { $md } = useNuxtApp()
const getTitle = computed(() => $md.renderInline(props.contentMainHeadlineConfig?.title || ''))

const getHeadlineClasses = computed(() => {
    return {
        'content-main-headline-simple': props.contentMainHeadlineConfig.simple,
        'content-main-headline-centered': props.contentMainHeadlineConfig.align === 'center',
        'content-main-headline-two-lines': props.contentMainHeadlineConfig.twoLines
    }
})
</script>

<template>
    <h1 v-if="contentMainHeadlineConfig.title" class="content-main-headline" :class="getHeadlineClasses" v-html="getTitle" />
</template>

<style lang="scss">
.content-main-headline {
    max-width: 950px;

    @include superheadline-h1($margin: 0 0 px2rem(20));

    @include bp(large1) {
        margin-bottom: 30px;
    }

    &.content-main-headline-simple {
        padding-inline: 0;

        &::before {
            display: none;
        }
    }

    &.content-main-headline-two-lines {
        em {
            display: block;
        }
    }

    &.content-main-headline-centered {
        text-align: center;
        display: inline-block;

        em {
            text-align: center;
        }
    }
}
</style>
